import { render } from "./ThisWeeksSalesPurchasesChart.vue?vue&type=template&id=21e8ca4e&scoped=true&ts=true"
import script from "./ThisWeeksSalesPurchasesChart.vue?vue&type=script&lang=ts"
export * from "./ThisWeeksSalesPurchasesChart.vue?vue&type=script&lang=ts"

import "./ThisWeeksSalesPurchasesChart.vue?vue&type=style&index=0&id=21e8ca4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21e8ca4e"]])

export default __exports__